export const getDefaultAvatarUrl = (index: number) => {
    return `https://cdn.discordapp.com/embed/avatars/${index % 5}.png`;
};

export const getDiscordAvatarUrl = (userId: string, avatarHash: string | null, size = 64) => {
    if (!avatarHash) {
        const index = Number(BigInt(userId) >> BigInt(22)) % 6;
        return `https://cdn.discordapp.com/embed/avatars/${index}.png`;
    }
    if (avatarHash.startsWith('http')) {
        return avatarHash;
    }
    const ext = avatarHash.startsWith('a_') ? 'gif' : 'webp';
    return `https://cdn.discordapp.com/avatars/${userId}/${avatarHash}.${ext}?size=${size}`;
};

export const getGuildIconUrl = (guildId: string, iconHash: string | null, size = 32) => {
    if (!iconHash) return null;
    const ext = iconHash.startsWith('a_') ? 'gif' : 'webp';
    return `https://cdn.discordapp.com/icons/${guildId}/${iconHash}.${ext}?size=${size}`;
};

export const formatDuration = (durationMs?: number): string => {
    if (!durationMs || durationMs < 60_000) return '< 1m';
    const hours = Math.floor(durationMs / 3_600_000);
    const minutes = Math.floor((durationMs % 3_600_000) / 60_000);
    if (hours > 0) {
        return `${hours}h ${minutes.toString().padStart(2, '0')}m`;
    }
    return `${minutes}m`;
};

export const formatTimestamp = (ts?: string | null): string => {
    if (!ts) return 'N/A';
    return new Date(ts).toLocaleString();
};

export const formatRelativeTime = (ts?: string | null): string => {
    if (!ts) return 'N/A';
    const date = new Date(ts);
    const now = new Date();
    const diffMs = now.getTime() - date.getTime();
    const diffMins = Math.floor(diffMs / 60000);
    const diffHours = Math.floor(diffMs / 3600000);
    const diffDays = Math.floor(diffMs / 86400000);

    if (diffMins < 1) return 'Just now';
    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString();
};
